import { Form } from 'antd';
import { FormItemProps } from 'antd/es/form';
import React from 'react';
import Label from '../../components/Label/Label';
import styles from './FormItem.module.scss';

interface Props extends Omit<FormItemProps, 'style'> {
  label?: string;
  children: React.ReactNode;
  style?: string | string[];
}

const FormItem = ({label, children, style, ...props}: Props) => {
  if(Array.isArray(style)) style = style.join(' ')
  
  return (
    <Form.Item
      className={`${styles.item} ${style}`}
      label={label && <Label>{label}</Label>}
      {...props}
    >
      {children}
    </Form.Item>
  );
};

export const FileFormItem = ({ label, children, style, rules=[], ...props }: Props) => {
  if (Array.isArray(style)) style = style.join(' ')

  rules.push({
    validator: (_, file) => {
      const maxSize = 1000000; // 1 MB

      if (!file) return Promise.resolve();

      if (file.size > maxSize) {
        return Promise.reject(new Error('Arquivo muito grande, por favor escolha uma menor que um 1 MB'));
      }
      return Promise.resolve();
    }
  })

  return (
    <Form.Item
      className={`${styles.item} ${style}`}
      label={label && <Label>{label}</Label>}
      rules={rules}
      {...props}
    >
      {children}
    </Form.Item>
  );
};

export default FormItem;
